import debounce from "lodash/debounce"

export default function docsSetup(navSelector, docsSelector) {
  highlightNavOnScroll(navSelector, docsSelector)
}

function highlightNavOnScroll(navSelector, docsSelector) {
  const navSelectorEl = document.querySelector(navSelector)
  const docsSelectorEl = document.querySelector(docsSelector)
  if (!navSelectorEl) return

  const $navigationLinks = navSelectorEl.querySelectorAll("li a")
  const $navigationLinksBySectionId = {}

  $navigationLinks.forEach(link => {
    const sectionId = link.hash && link.hash.slice(1)

    if (sectionId) {
      $navigationLinksBySectionId[sectionId] = link
    }
  })

  const $sectionHeaders = []

  docsSelectorEl.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach(header => {
    if (header.id in $navigationLinksBySectionId) {
      $sectionHeaders.unshift(header)
    }
  })

  const handler = debounce(
    handleScroll.bind(null, docsSelectorEl, $sectionHeaders, $navigationLinks, $navigationLinksBySectionId),
    100
  )
  handler()
  docsSelectorEl.addEventListener("scroll", handler)
}

function handleScroll(docsSelectorEl, $sectionHeaders, $navigationLinks, $navigationLinksBySectionId) {
  const scrollPosition = docsSelectorEl.offsetTop + docsSelectorEl.scrollTop

  $sectionHeaders.some($sectionHeader => {
    // Add a buffer of 10-ish extra pixels above each header, since the `top`
    // is below the point the browser navigates to when you go to the anchor.
    const sectionTop = $sectionHeader.offsetTop - 10

    if (scrollPosition >= sectionTop) {
      const $navigationLink = $navigationLinksBySectionId[$sectionHeader.id]

      if (!$navigationLink.classList.contains("active")) {
        $navigationLinks.forEach(el => el.classList.remove("active"))
        $navigationLink.classList.add("active")
      }

      return true
    }
  })
}
